export async function downloadPrefilledAdmissionTemplate(base, date = '2024-10-24') {
    const r = await fetch(`${base.replace(/\/$/, '')}/identity/members/admission-import/template?date=${encodeURIComponent(date)}`, { credentials: 'include' });
    if (!r.ok) {
        const b = await r.json().catch(() => ({}));
        throw new Error(b.message ?? 'No se pudo preparar el padrón.');
    }
    const disposition = r.headers.get('content-disposition') ?? '', match = disposition.match(/filename\*=UTF-8''([^;]+)/);
    return {
        blob: await r.blob(),
        fileName: match ? decodeURIComponent(match[1]) : `fechas-alicuotas-${date}.csv`,
        rowCount: Number(r.headers.get('x-urbanik-row-count') ?? 0),
    };
}
export async function previewAdmissionImport(base, file) {
    const r = await fetch(`${base.replace(/\/$/, '')}/identity/members/admission-import/preview`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ fileName: file.name, content: await file.text() }),
    });
    const b = await r.json();
    if (!r.ok)
        throw new Error(b.message ?? 'No se pudo revisar la plantilla.');
    return b;
}
export async function confirmAdmissionImport(base, batchId, file) {
    const r = await fetch(`${base.replace(/\/$/, '')}/identity/members/admission-import/confirm`, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/pdf',
            'X-Urbanik-Batch-Id': encodeURIComponent(batchId),
            'X-Urbanik-File-Name': encodeURIComponent(file.name),
        },
        body: file,
    });
    const b = await r.json();
    if (!r.ok)
        throw new Error(b.message ?? 'No se pudo confirmar la carga.');
    return b;
}
export async function getRemainingAdmissionVerification(base) {
    const response = await fetch(`${base.replace(/\/$/, '')}/identity/members/admission-verification/remaining`, { credentials: 'include' });
    const body = await response.json();
    if (!response.ok)
        throw new Error(body.message ?? 'No se pudieron consultar las fechas provisionales.');
    return body;
}
export async function verifyRemainingAdmissions(base, input) {
    const response = await fetch(`${base.replace(/\/$/, '')}/identity/members/admission-verification/remaining`, {
        method: 'POST',
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/pdf',
            'X-Urbanik-Reference': encodeURIComponent(input.reference),
            'X-Urbanik-Reason': encodeURIComponent(input.reason),
            'X-Urbanik-File-Name': encodeURIComponent(input.file.name),
        },
        body: input.file,
    });
    const body = await response.json();
    if (!response.ok)
        throw new Error(body.message ?? 'No se pudieron verificar las fechas restantes.');
    return body;
}
